import { css } from '@emotion/css';

export const selectStyles = css`
  .MuiInputBase-root,
  .MuiAutocomplete-input {
    cursor: pointer;
  }

  .MuiInputBase-input::selection {
    background-color: transparent;
  }

  .MuiInputBase-input[readonly] {
    -webkit-user-select: none;
    user-select: none;
  }
`;
